import { useState } from 'react'
import {
  Modal, Stack, Text, PasswordInput, Group, Button, Anchor,
} from '@mantine/core'

interface Props {
  opened: boolean
  onClose: () => void
  onSubmit: (value: string) => void
}

export function PasteKeyModal({ opened, onClose, onSubmit }: Props) {
  const [value, setValue] = useState('')
  const trimmed = value.trim()
  const isValid = trimmed.length > 0

  function handleClose() {
    setValue('')
    onClose()
  }

  function handleSubmit() {
    onSubmit(trimmed)
    setValue('')
  }

  return (
    <Modal opened={opened} onClose={handleClose} title="Colar API Key para esta sessão" centered>
      <Stack gap="sm">
        <Text size="sm" c="dimmed">
          Cole o valor completo da sua API Key do WhatsApi. Ela fica em memória apenas nesta aba
          (sessionStorage) e é descartada quando a aba for fechada. Não enviamos a key para o servidor.
        </Text>
        <PasswordInput
          placeholder="wha_..."
          value={value}
          onChange={(e) => setValue(e.currentTarget.value)}
          autoFocus
          aria-label="API Key"
          visibilityToggleIcon={() => null}
          data-sensitive="true"
          wrapperProps={{ 'data-sensitive': 'true' }}
        />
        <Group justify="flex-end">
          <Button variant="subtle" onClick={handleClose}>Cancelar</Button>
          <Button disabled={!isValid} onClick={handleSubmit}>Salvar para sessão</Button>
        </Group>
        <Text size="xs" c="dimmed">
          Não tem uma key? <Anchor href="/whatsapi/api-keys">Criar API Key →</Anchor>
        </Text>
      </Stack>
    </Modal>
  )
}
